import ih from 'immutability-helper';
import createPaginatedListReducerWithNamedType from 'store/hoReducers/paginatedList/reducer';
import { PURGE_ACTIONS } from 'store/services/project/actionTypes';
import initialState from './initialState';
import * as types from './actionTypes';

const reducerHandlers = (state = initialState, action = {}) => ({
  ADD_DICTIONARY_SUCCESS: () =>
    ih(state, {
      add: {
        isLoading: {
          $set: false,
        },
      },
    }),
  [PURGE_ACTIONS]: () => ({
    ...state,
    show: {
      ...state.show,
      data: !action.payload.data.dictionaries.includes(state.show.data.id)
        ? state.show.data
        : {},
    },
  }),
  [types.EXPORT_DICTIONARY_REQUEST]: () => ({
    ...state,
    partialExport: {
      ...state.partialExport,
      isLoading: true,
    },
  }),
  [types.EXPORT_DICTIONARY_SUCCESS]: () => ({
    ...state,
    partialExport: {
      ...state.partialExport,
      isLoading: false,
    },
  }),
  [types.EXPORT_DICTIONARY_ERROR]: () => ({
    ...state,
    partialExport: {
      ...state.export,
      isLoading: false,
      error: action.payload.error,
    },
  }),
});

export default createPaginatedListReducerWithNamedType(
  'DICTIONARY',
  initialState,
  reducerHandlers,
);
